import Moment from 'moment'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import ETable from '../../../elements/components/table'
import UserContext from '../../../UserContext'

const propTypes = {
    items: PropTypes.array,
    selected: PropTypes.array,
    type: PropTypes.number,
    page: PropTypes.number,
    perPage: PropTypes.number,
    onPageChange: PropTypes.func,
    onConfirm: PropTypes.func,
    onRevert: PropTypes.func,
    onAudit: PropTypes.func
}
const defaultProps = {
    items: [],
    selected: [],
    page: 1,
    perPage: 9999
}

class OverviewTable extends Component {

    static contextType = UserContext;

    constructor(props) {
        super(props);
        this.state = {
            hovered: false
        };
    }

    render() {

        const { user } = this.context;

        const columns = [
            //{
            //    dataField: 'selected',
            //    text: '',
            //    headerClasses: 'align-top',
            //    classes: 'align-middle',
            //    headerFormatter: (column, index) => (
            //        <div className="custom-control custom-control-inline custom-checkbox custom-control-nameless m-0">
            //            <input
            //                type="checkbox"
            //                className="custom-control-input"
            //                id="all-items"
            //                checked={this.props.items.length === this.props.selected.length}
            //                onChange={(e) => this.props.onSelectAll(e.target.checked)} />
            //            <label className="custom-control-label" htmlFor="all-items"></label>
            //        </div>
            //    ),
            //    formatter: (selected, row, index) => (
            //        <div className="custom-control custom-control-inline custom-checkbox custom-control-nameless m-0 align-top">
            //            <input
            //                type="checkbox"
            //                className="custom-control-input"
            //                id={'item-' + row.id}
            //                checked={selected ? true : false}
            //                onChange={(e) => this.props.onSelect(row.id, e.target.checked)} />
            //            <label className="custom-control-label" htmlFor={'item-' + row.id}></label>
            //        </div>
            //    )
            //},
            {
                dataField: 'CISLOZAKAZKY',
                text: 'Číslo',
                sort: true,
                classes: 'text-nowrap align-middle',
                formatter: (cell, row, index) => (
                    <span onClick={() => this.props.onAudit(row)}
                        title={ "Historie zakázky na lakovně" }
                        style={{ cursor: "pointer", color: "#3c91da" }}>
                        {cell}
                    </span>
                )
            },
            {
                dataField: 'PRIJMENI',
                text: 'Zakázka',
                sort: true,
                headerClasses: 'max-width',
                classes: 'text-nowrap align-middle'
            },
            {
                dataField: 'MANDANT_NAZEV',
                text: 'Lakýrník',
                sort: true,
                hidden: (!user.canRevert || this.props.type !== 3),
                classes: 'text-nowrap align-middle'
            },
            {
                dataField: 'LAKOVNA_TYP_MATERIALU_POPIS',
                text: 'Materiál',
                sort: true,
                classes: 'text-nowrap align-middle'
            },
            {
                dataField: 'LAKOVNA_AKCE_POPIS',
                text: 'Akce',
                sort: true,
                classes: 'text-nowrap align-middle'
            },
            {
                dataField: 'PLOCHA_LAKOVNA',
                text: 'Plocha',
                sort: true,
                classes: 'text-nowrap align-right'
            },
            {
                dataField: 'POZADOVANY_DATUM_AKCE',
                text: 'Termín',
                classes: 'text-nowrap align-middle',
                sort: true,
                formatter: (cell, row, index) => (
                    <span className={(this.props.type === 3 ? null : Moment(cell).toDate() < Moment().add(-1, 'days').toDate() ? "text-danger" : "")}>{Moment(cell).format('DD.MM.YYYY')}</span>
                )
            },
            {
                dataField: 'SKUTECNY_DATUM_AKCE',
                hidden: (this.props.type === 1 || this.props.type === 2),
                text: 'Skut. termín',
                classes: 'text-nowrap align-middle',
                sort: true,
                formatter: (cell, row, index) => (
                    <span>{(cell ? Moment(cell).format('DD.MM.YYYY') : null)}</span>
                )
            },
            {
                dataField: '',
                text: '',
                hidden: !(user && (user.canEdit || user.canRevert) && this.props.onConfirm && this.props.onRevert),
                classes: 'text-center align-middle noprint',
                formatter: (cell, row, index) => (
                    <div className="btn-group align-top">
                        <button
                            hidden={(!user.canRevert || this.props.type !== 3)}
                            className="btn btn-sm btn-outline-secondary badge"
                            type="button"
                            onClick={() => this.props.onRevert(row)}>Vrátit</button>
                        
                        <button
                            hidden={!user.canEdit || this.props.type === 3}
                            className="btn btn-sm btn-outline-secondary badge"
                            type="button"
                            onClick={() => this.props.onConfirm(row)}>Hotovo</button>
                    </div>
                )
            }
            //{
            //    dataField: 'status',
            //    text: ' ',
            //    classes: 'text-center align-middle',
            //    formatter: (cell, row, index) => (
            //        <i
            //            className={classNames(
            //                'fa fa-fw text-secondary cursor-pointer',
            //                cell ? 'fa-toggle-on' : 'fa-toggle-off'
            //            )}
            //            onClick={() => this.props.onStatusChange(row.id, !cell)} />
            //    )
            //},
        ]


        return (
            <ETable
                className="table-lg"
                keyField='ZAKAZKA_LAKOVNA_TERMIN_ID'
                data={this.props.items}
                columns={columns}
                pagination={{
                    page: this.props.page,
                    sizePerPage: this.props.perPage,
                    onPageChange: this.props.onPageChange
                }} />
        )
    }
}

OverviewTable.propTypes = propTypes
OverviewTable.defaultProps = defaultProps

export default OverviewTable
